/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetAodScheduledRunsScheduledRunsForRuleQueryResponse, GetAodScheduledRunsScheduledRunsForRulePathParams, GetAodScheduledRunsScheduledRunsForRule404 } from "../models/GetAodScheduledRunsScheduledRunsForRule";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getAodScheduledRunsScheduledRunsForRule } from "../axios/getAodScheduledRunsScheduledRunsForRule";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getAodScheduledRunsScheduledRunsForRuleQueryKey = (ruleId: GetAodScheduledRunsScheduledRunsForRulePathParams["ruleId"]) => ["audit-reports-api", { url: '/aod-runs/scheduled/rules/:ruleId', params: {ruleId:ruleId} }] as const

export type GetAodScheduledRunsScheduledRunsForRuleQueryKey = ReturnType<typeof getAodScheduledRunsScheduledRunsForRuleQueryKey>

export function getAodScheduledRunsScheduledRunsForRuleQueryOptions(ruleId: GetAodScheduledRunsScheduledRunsForRulePathParams["ruleId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getAodScheduledRunsScheduledRunsForRuleQueryKey(ruleId)
        return queryOptions<GetAodScheduledRunsScheduledRunsForRuleQueryResponse, ResponseErrorConfig<GetAodScheduledRunsScheduledRunsForRule404>, GetAodScheduledRunsScheduledRunsForRuleQueryResponse, typeof queryKey>({
         enabled: !!(ruleId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getAodScheduledRunsScheduledRunsForRule(ruleId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves all future scheduled runs (enqueued jobs) for a specific AOD rule
 * @summary Get scheduled runs for an AOD rule
 * {@link /aod-runs/scheduled/rules/:ruleId}
 */
export function useGetAodScheduledRunsScheduledRunsForRule<TData = GetAodScheduledRunsScheduledRunsForRuleQueryResponse, TQueryData = GetAodScheduledRunsScheduledRunsForRuleQueryResponse, TQueryKey extends QueryKey = GetAodScheduledRunsScheduledRunsForRuleQueryKey>(ruleId: GetAodScheduledRunsScheduledRunsForRulePathParams["ruleId"], options: 
{
  query?: Partial<QueryObserverOptions<GetAodScheduledRunsScheduledRunsForRuleQueryResponse, ResponseErrorConfig<GetAodScheduledRunsScheduledRunsForRule404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getAodScheduledRunsScheduledRunsForRuleQueryKey(ruleId)
         

         const query = useQuery({
          ...getAodScheduledRunsScheduledRunsForRuleQueryOptions(ruleId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetAodScheduledRunsScheduledRunsForRule404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}